<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             :title="(editing ? 'Editar' : 'Crear') + ' Capacitación' "
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="trainings"
        >
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label for="code">Código</label>
                        <el-input id="code"
                                  name="code"
                                  size="small"
                                  disabled
                                  v-model="training.code"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:10'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('trainings.code')"
                        />
                        <span class="text-success small float-right">
                            El código será generado automáticamente en el momento de la creación
                        </span>
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label class="sm-form-control">Fecha</label>
                        <el-date-picker id="date"
                                        name="date"
                                        size="small"
                                        class="w-100"
                                        v-model="training.date"
                                        type="date"
                                        :clearable="false"
                                        :disabled-dates="{ to: new Date() }"
                                        placeholder="Seleccione una fecha"
                                        data-vv-as=" "
                                        v-validate="'required'"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                        <div class="text-danger small"
                             v-text="errors.first('trainings.date')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  v-model="training.name"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('trainings.name')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="wor_training_company_id">Empresa formadora</label>
                        <el-select v-model="training.wor_training_company_id"
                                   id="wor_training_company_id"
                                   name="wor_training_company_id"
                                   filterable
                                   remote
                                   size="small"
                                   placeholder="Seleccione empresa formadora"
                                   class="w-100"
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   v-validate="'required'"
                        >
                            <el-option v-for="training_company in training_companies"
                                       :key="training_company.id"
                                       :label="training_company.name"
                                       :value="training_company.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('trainings.wor_training_company_id')"
                        />
                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="workers">Trabajadores</label>
                        <el-select v-model="training.workers"
                                   id="workers"
                                   name="workers"
                                   multiple
                                   filterable
                                   size="small"
                                   placeholder="Seleccione Trabajadores"
                                   class="w-100"
                                   allow-create
                                   no-data-text="No hay datos que coincidan"
                                   no-match-text="No hay datos que coincidan"
                                   data-vv-as=" "
                                   v-validate="'required'"

                        >
                            <el-option v-for="worker in workers"
                                       :key="worker.id"
                                       :label="worker.names + ' ' + worker.surnames"
                                       :value="worker.id"
                            />
                        </el-select>
                        <div class="text-danger small"
                             v-text="errors.first('training.worker')"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <label for="intensity">Intensidad</label>
                        <el-input id="intensity"
                                  name="intensity"
                                  size="small"
                                  v-model="training.intensity"
                                  data-vv-as=" "
                                  type="number"
                                  v-validate="'required'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('trainings.intensity')"
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group>
                        <label for="topics">Temas</label>
                        <el-input id="topics"
                                  name="topics"
                                  type="textarea"
                                  rows="6"
                                  v-model="training.topics"
                                  data-vv-as=" "
                                  v-validate="'required'"
                        />
                        <div class="text-danger small"
                             v-text="errors.first('trainings.topics')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <div class="w-100 text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Guardar
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setModalShow(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </div>
            </b-row>
        </b-form>
    </b-modal>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'modal',
    computed: {
        ...mapState('trainings', [
            'training',
            'editing',
            'modal',
            'training_companies',
            'workers'
        ])
    },
    created() {
        this.resetParams();
    },
    methods: {
        ...mapActions('trainings', [
            'addTraining',
            'updateTraining',
            'fetchWorkers'
        ]),
        ...mapMutations('trainings', [
            'resetParams',
            'setModalShow'
        ]),
        validateForm() {
            this.$validator.validateAll('trainings')
                .then((result) => {
                    if (result) {
                        if (this.editing) {
                            this.updateTraining();
                        } else {
                            this.addTraining();
                        }
                    }
                });
        }
    },
};
</script>

<style scoped>
</style>
